import {
  Tab as StageTenTab,
  TabContent as StageTenTabContent,
  TabsList as StageTenTabsList,
  TabsRoot as StageTenTabsRoot,
} from "@lazarentertainment/web-design-system/components/tabs"
import { ComponentPropsWithoutRef } from "react"

export type TabsRootProps = Omit<
  ComponentPropsWithoutRef<typeof StageTenTabsRoot>,
  "variant"
>

export const TabsRoot = ({ ...props }: TabsRootProps) => {
  return (
    <StageTenTabsRoot variant="default" {...props}>
      {props.children}
    </StageTenTabsRoot>
  )
}

export const tabVariants = ["default", "rose"] as const

export type TabProps = ComponentPropsWithoutRef<typeof StageTenTab> & {
  /**
   * Indicates the colour/variant tab button
   *
   * @default default
   */
  variant?: (typeof tabVariants)[number]
}

export const Tab = ({ variant = "default", ...props }: TabProps) => {
  return (
    <StageTenTab data-variant={variant} {...props}>
      {props.children}
    </StageTenTab>
  )
}

export const TabsList = StageTenTabsList
export const TabContent = StageTenTabContent
